module.exports = __webpack_public_path__ + "041167dc9692ae587a874ad50a2f8ef6.svg";


//////////////////
// WEBPACK FOOTER
// ../~/file-loader!./blocks/Footer/assets/scandgate-white.svg
// module id = 503
// module chunks = 0 1